import React from 'react';
import { useTranslation } from "react-i18next";
import IllustrationInvoices from '../assets/img/Illustration-Invoices.png';

interface EmptyStateProps {
  title: string;
  description: string;
  illustrationSrc?: string;
  illustrationPosition?: 'top' | 'bottom';
  illustrationWidth?: number | string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  illustrationSrc = IllustrationInvoices,
  illustrationPosition = 'bottom',
  illustrationWidth,
}) => {
  const { t } = useTranslation();

  const illustration = (
    <img
      src={illustrationSrc}
      alt={t('empty_state_no_data')}
      className="empty-state__illustration"
      style={illustrationWidth !== undefined ? { width: illustrationWidth } : { width: 150 }}
    />
  );

  return (
    <div className={`empty-state${illustrationPosition === 'top' ? ' empty-state--illustration-top' : ''}`}>
      <div className="empty-state__content">
        {illustrationPosition === 'top' && illustration}
        <h3 className="empty-state__title">
          {title}
        </h3>
        <p className="empty-state__description">
          {description}
        </p>
        {illustrationPosition === 'bottom' && illustration}
      </div>
    </div>
  );
};

export default EmptyState;
